import ArDriveLogo from '../../../assets/svg/ardrive-logo.png';
import R2Logo from '../../../assets/svg/r2-logo.svg';
import S3Logo from '../../../assets/svg/s3-logo.png';
import { isUploadProviderEnabled } from '../../../utils/providerHelpers';
import { ArDriveConfigSection } from './ArDriveConfig';
import { R2ConfigSection } from './R2Config';
import { S3ConfigSection } from './S3Config';
import type { ProviderConfig, ProviderInfo } from './types';

export const providerInfo: Record<string, ProviderInfo> = {
  ardrive: {
    name: 'ArDrive',
    description:
      'Decentralized permanent storage powered by Arweave with built-in file management',
    features: [
      'Stream-based uploads for large files',
      'Built-in retry logic',
      'Progress tracking',
      'Pay with Turbo credits',
    ],
    cost: 'Pay-as-you-go with Turbo credits',
  },
  s3: {
    name: 'AWS S3',
    description:
      'Use your own AWS S3 bucket for complete control over your data storage',
    features: [
      'Full control over your data',
      'Direct browser-to-S3 uploads',
      'Cost-effective for large files',
      'No third-party dependencies',
      'Encrypted credential storage',
    ],
    cost: 'AWS S3 pricing (pay for what you use)',
  },
  r2: {
    name: 'Cloudflare R2',
    description:
      'Use the portal-owned Cloudflare R2 NFT bucket with backend-issued uploads and stable public asset URLs',
    features: [
      'No browser-stored credentials',
      'Direct browser-to-R2 uploads',
      'Stable public custom-domain URLs',
      'Provider-aware deduplication',
      'Portal-managed first-party storage',
    ],
    cost: 'Managed by the portal',
  },
};

const allProviders: ProviderConfig[] = [
  {
    id: 'r2',
    info: providerInfo.r2,
    logo: R2Logo,
    ConfigSection: R2ConfigSection,
  },
  {
    id: 'ardrive',
    info: providerInfo.ardrive,
    logo: ArDriveLogo,
    ConfigSection: ArDriveConfigSection,
  },
  {
    id: 's3',
    info: providerInfo.s3,
    logo: S3Logo,
    ConfigSection: S3ConfigSection,
  },
];

export const providers = allProviders.filter((provider) =>
  isUploadProviderEnabled(provider.id),
);
